/**
 * API Service Layer
 * Handles all API calls to Netlify Functions
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || "/.netlify/functions";

/**
 * Helper function to make API calls
 */
async function apiCall(endpoint, method = "POST", data = null) {
  try {
    const options = {
      method,
      headers: {
        "Content-Type": "application/json"
      }
    };

    if (data) {
      options.body = JSON.stringify(data);
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, options);
    // const result = await response.json();
    const result = await response.body
      .getReader()
      .read()
      .then(({ value }) => {
        return JSON.parse(new TextDecoder("utf-8").decode(value));
      });

    if (!response.ok) {
      throw new Error(result.message || "API call failed");
    }

    return result;
  } catch (error) {
    console.error(`API call error (${endpoint}):`, error);
    throw error;
  }
}

/**
 * Step 1: Initiate user registration
 * Sends verification email with OTP
 */
export async function initiateRegistration(
  email,
  code,
  password,
  recaptchaToken,
  firstName = "",
  lastName = ""
) {
  return apiCall("/auth-register-user", "POST", {
    email,
    code,
    password,
    recaptchaToken,
    firstName,
    lastName
  });
}

/**
 * Step 2: Authorize with OTP
 * Verifies the OTP sent via email and returns authorization code
 */
export async function authorizeRegistration(
  identifier,
  otp,
  clientId = null,
  redirectUri = null
) {
  return apiCall("/auth-authorize", "POST", {
    identifier,
    otp,
    clientId,
    redirectUri
  });
}

/**
 * Step 3: Exchange authorization code for access token
 * Final step of OAuth flow
 */
export async function exchangeToken(authorizationCode, redirectUri = null) {
  return apiCall("/auth-token-exchange", "POST", {
    authorizationCode,
    redirectUri
  });
}

/**
 * Complete registration flow (legacy - all in one)
 * Invitation validation happens during registration
 */
export async function registerUser(
  email,
  code,
  password,
  recaptchaToken,
  firstName = "",
  lastName = ""
) {
  return apiCall("/auth-register-user", "POST", {
    email,
    code,
    password,
    recaptchaToken,
    firstName,
    lastName
  });
}

/**
 * Login user
 */
export async function loginUser(email, password, recaptcha) {
  return apiCall("/auth-login", "POST", { email, password, recaptcha });
}

export default {
  initiateRegistration,
  authorizeRegistration,
  exchangeToken,
  registerUser,
  loginUser
};
